module.exports = __webpack_public_path__ + "static/media/22-6.b18a9d3d.mp3";